import { useState, useCallback } from 'react';
import { useApi } from '../../../../hooks/useApi';

export default function useInforme() {
  const { request } = useApi();
  const [estado, setEstado] = useState("idle");
  const [error, setError] = useState(null);
  const [parseado, setParseado] = useState(null);
  const [archivoOriginal, setArchivoOriginal] = useState(null);
  const [guardados, setGuardados] = useState([]);

  const cargarGuardados = useCallback(async () => {
    try {
      const res = await request('/invent/informes', 'GET');
      if (res && res.success) {
        // Extraemos el array correctamente
        const arrayReal = Array.isArray(res.data) 
          ? res.data 
          : (res.data?.data && Array.isArray(res.data.data) ? res.data.data : []);
        setGuardados(arrayReal);
      }
    } catch (err) { 
      console.error("Error al cargar informes:", err); 
    }
  }, [request]);

  const subirArchivo = useCallback(async (archivo) => {
    if (!archivo) return;
    setArchivoOriginal(archivo);
    setEstado("uploading");
    setError(null);
    const formData = new FormData();
    formData.append("archivo", archivo);

    try {
      setEstado("parsing");
      const token = localStorage.getItem("token");
      const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      const response = await fetch(`${baseUrl}/api/invent/informes/procesar`, {
        method: 'POST',
        headers: { ...(token && { Authorization: `Bearer ${token}` }) },
        body: formData
      });
      
      const text = await response.text();
      let data = {};
      try { data = JSON.parse(text); } catch(e) {}
      
      if (!response.ok) throw new Error(data.error || data.message || "Error al procesar el archivo");
      
      setParseado(data);
      setEstado("ready");
    } catch (err) {
      setError(err.message);
      setEstado("error");
    }
  }, []);

  const guardarInforme = useCallback(async (datosInforme) => {
    const res = await request('/invent/informes/guardar', 'POST', { ...datosInforme, archivo: parseado });
    if (!res.success) throw new Error("No se pudo guardar");
    await cargarGuardados();
  }, [request, parseado, cargarGuardados]);

  const eliminarInforme = useCallback(async (id) => {
    const res = await request(`/invent/informes/${id}`, 'DELETE');
    if (!res.success) throw new Error("No se pudo eliminar");
    await cargarGuardados();
  }, [request, cargarGuardados]);

  const reset = useCallback(() => {
    setEstado("idle"); setError(null); setParseado(null); setArchivoOriginal(null);
  }, []);

  return { estado, error, parseado, archivoOriginal, guardados, subirArchivo, guardarInforme, cargarGuardados, eliminarInforme, reset };
}